/** @jsxImportSource @emotion/react */
import type { ReactNode } from 'react';
import { css } from '@emotion/react';
import { theme } from '../theme/theme';
import type { SpaceKey } from '../theme/theme';

export interface GridProps {
  children: ReactNode;
  /** 열 수. 대시보드 패널 격자는 2. */
  cols?: number;
  /** 비균등 격자 정의. 예: "2fr 1fr" (그리드+상세 패널). 지정 시 cols 무시. */
  template?: string;
  gap?: SpaceKey;
}

/** 격자 프리미티브. 패널 카드 격자, 스탯 타일 격자에 활용. */
export function Grid({ children, cols = 2, template, gap = 'md' }: GridProps) {
  return (
    <div
      css={css`
        display: grid;
        grid-template-columns: ${template ?? `repeat(${cols}, minmax(0, 1fr))`};
        gap: ${theme.space[gap]}px;
      `}
    >
      {children}
    </div>
  );
}
